module.exports = __webpack_public_path__ + "img/clamping_thread_cutting_die.prt.62d7eeda.jpg";